import { LayoutOutlined } from '@ant-design/icons'
import { clsx } from 'clsx'
import { FormikContext, useFormik } from 'formik'
import { FC, forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'

import { ProjectCreationForm } from './project-creation-interface'
import { ProjectCreationValidationSchema } from './validators/project-creation-validation-schema'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'

type ProjectCreationProps = {
  initialValue?: ProjectCreationForm
}

export const ProjectCreationSection: FC<ProjectCreationProps> = forwardRef(({ initialValue }: ProjectCreationProps, ref) => {
  const { t } = useTranslation()

  const formik = useFormik<ProjectCreationForm>({
    initialValues: initialValue || { name: '' },
    validationSchema: ProjectCreationValidationSchema(),
    onSubmit: () => {},
  })

  useImperativeHandle(ref, () => ({
    getValues: () => {
      return {
        errors: formik.validateForm(),
        values: formik.values,
      }
    },
  }))

  return (
    <FormikContext.Provider value={formik as any}>
      <h2 className="mt-3 mb-5">{t('projectCreation.title')}</h2>
      <form
        className={clsx('step-wrapper row bg-white rounded-4 pb-5 pt-4 px-1 px-md-3 px-lg-5 mb-5 gx-5')}
        onSubmit={formik.handleSubmit}
      >
        <PureInput
          {...formik.getFieldProps('name')}
          error={formik.errors.name}
          icon={<LayoutOutlined />}
          label={t('projectCreation.nameLabel')}
          moduleStyle="mb-3"
          placeholder={t('projectCreation.placeholder')}
          required={false}
        />
      </form>
    </FormikContext.Provider>
  )
})
